// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"fa6b025a","142":"19ee87f4","157":"c39bcf93","455":"b9ad18a1","946":"714eaeca","993":"da57b247"}[chunkId] + ".chunk.js";
};